// import { ThreadTrait, ButtonTrait, ShopDataTrait, ShirtGalleryTrait } from './traits';
import { ThreadTrait, ButtonTrait, FabricTrait, ShirtGalleryTrait, ShopDataTrait, AuthenticationTrait } from './traits';
import { applyMixins } from './utils';
import { ServiceConfig } from './types';
import Base from './base';
import Dictionary from './collection';
import {createIntl, createIntlCache, IntlCache, IntlShape } from '@formatjs/intl'
import { deMessages, enMessages } from './translations';

class ClientBase extends Base {

	/**
	 * @type {IntlCache}
	 */
	private translateCache: IntlCache;

	/**
	 * @type {IntlShape}
	 */
	private translator: IntlShape;

	/**
	 * @param {Config} config
	 * @param {string = 'de'} lang
	 */
	constructor(config: ServiceConfig, lang: string = 'de') {
		super(config);
		this.translateCache = createIntlCache();

		let messages = {};
		switch(lang) {
			case 'en':
				Object.assign(messages, enMessages.translations);
				break;
			case 'de':
			default:
				Object.assign(messages, deMessages.translations);
				break;
		}

		this.translator = createIntl({
			locale: lang,
			defaultLocale: 'de',
			messages: messages
		}, this.translateCache);
	}

	/**
     * Use this function to do a literal translation based on a
     * translation key. You can provide as many parameters as 
     * needed.
	 * @param {string} key
	 * @param {any[]}  ...params
	 */
	public t(key: string, ...params: any[]) {
		params = (params.length > 0) ? params.shift() : {};
		return this.translator.formatMessage({ id: key }, params);
	}

	/**
     * Use this function to translate a string with multiple keys
     * in it (e.g. "50% [[Cotton]] 25% [[Polyester]]"). It will split
     * the translation keys and translate them individually. 
	 * @param {string} string
	 * @param {any[]}  ...params
	 */
	public tt(string: string, ...params: any[]) {
		const translationKeys = string.match(/\[\[([^\[]*)]/g);
		params = (params.length > 0) ? params.shift() : {};
		(translationKeys as string[]).map(key => {
			let translatedKey = this.translator.formatMessage({ id: key }, params);
			string = string.replace(key, translatedKey);
		});
		return string;
	}

}

interface ClientBase extends ThreadTrait, ButtonTrait, FabricTrait, ShirtGalleryTrait, ShopDataTrait, AuthenticationTrait {}
applyMixins(ClientBase, [ThreadTrait, ButtonTrait, FabricTrait, ShirtGalleryTrait, ShopDataTrait, AuthenticationTrait]);
export default ClientBase